import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { withSentryRouting } from '@sentry/react';
import { ImageLibraryContainer } from './ImageLibraryContainer';
import { TextLibraryContainer } from './TextLibraryContainer';
import { MediaVariations } from './MediaVariations';
import { TextEditorContainer } from './TextEditorContainer';
import { VideoLibraryContainer } from './VideoLibraryContainer';
import { ImageDetailsContainer } from './ImageDetailsContainer';

const SentryEnhancedRoute = withSentryRouting(Route);

export const MediaRoot = (props: RouteComponentProps) => {
  const { match } = props;

  const renderMediaRoot = () => <h1>Media root</h1>;

  return (
    <>
      <SentryEnhancedRoute path={match.url} exact render={renderMediaRoot} />
      <SentryEnhancedRoute path="/media/videos/:videoId?" component={VideoLibraryContainer} />
      <SentryEnhancedRoute path="/media/images" component={ImageLibraryContainer} />
      <SentryEnhancedRoute path="/media/images/:id" component={ImageDetailsContainer} />
      <Switch>
        <Redirect from="/media/textEdit/:id" to="/media/texts/:id" />
        <SentryEnhancedRoute path="/media/texts/:id" component={TextEditorContainer} />
        <SentryEnhancedRoute path="/media/texts" component={TextLibraryContainer} />
      </Switch>
      <SentryEnhancedRoute path="/media/variations" component={MediaVariations} />
    </>
  );
};
